const calculateChecksum = (weights: number[], kid: string, digitSum: boolean): number => {
    let checksum = 0;

    for (let i = 0; i < weights.length; i += 1) {
        const product = weights[i] * Number(kid.charAt(weights.length - 1 - i));
        if (digitSum) {
            checksum += product > 9 ? product - 9 : product;
        } else {
            checksum += product;
        }
    }

    return checksum;
};

const getMod10Weights = (kid: string) => {
    const weights: number[] = [];

    for (let i = 0; i < kid.length - 1; i += 1) {
        if (i % 2 === 0) {
            weights[i] = 2;
        } else {
            weights[i] = 1;
        }
    }

    return weights;
};

const getMod11Weights = (kid: string) => {
    const weights: number[] = [];
    const baseMod11Weights = [2, 3, 4, 5, 6, 7];

    for (let i = 0; i < kid.length - 1; i += 1) {
        const j = i % baseMod11Weights.length;
        weights[i] = baseMod11Weights[j];
    }

    return weights;
};

export const validateMod10CheckSum = (kid: string): boolean => {
    const weights = getMod10Weights(kid);
    const checksum = calculateChecksum(weights, kid, true) % 10;
    const checkDigit = kid.charAt(kid.length - 1);

    return checksum === 0 ? checkDigit === '0' : checkDigit === (10 - checksum).toString();
};

export const validateMod11CheckSum = (numbers: string, dashAllowed: boolean): boolean => {
    const weights = getMod11Weights(numbers);
    const checksum = calculateChecksum(weights, numbers, false) % 11;
    const checkDigit = numbers.charAt(numbers.length - 1);

    switch (checksum) {
        case 1:
            return dashAllowed && checkDigit === '-';
        case 0:
            return checkDigit === '0';
        default:
            return checkDigit === (11 - checksum).toString();
    }
};
